module.exports = __webpack_public_path__ + "static/assets/0ab2a6e89eb58f0d5406300d89a5d3f1.svg";